// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2cAduGLLx{color:var(--always-light-text);padding:4px 8px}._7C7Q347Ux{border-radius:4px}._1QicrVGjx{background-color:var(--alpha-10);color:var(--primary-text)}._1itYvucbx{background-color:#008571}._7FUBTnkxx{background-color:#2C7797}._1SXrF5sqx{background-color:#757575}.ekx0airrx{background-color:var(--error-text);color:var(--primary-text-invert)}._15Cnjypnx{background-color:var(--success-text);color:var(--primary-text-invert)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"state-label": "_2cAduGLLx",
	"stateLabel": "_2cAduGLLx",
	"rounded-corners": "_7C7Q347Ux",
	"roundedCorners": "_7C7Q347Ux",
	"state-none": "_1QicrVGjx",
	"stateNone": "_1QicrVGjx",
	"state-queued": "_1itYvucbx",
	"stateQueued": "_1itYvucbx",
	"state-inprogress": "_7FUBTnkxx",
	"stateInprogress": "_7FUBTnkxx",
	"state-canceled": "_1SXrF5sqx",
	"stateCanceled": "_1SXrF5sqx",
	"state-failed": "ekx0airrx",
	"stateFailed": "ekx0airrx",
	"state-succeeded": "_15Cnjypnx",
	"stateSucceeded": "_15Cnjypnx"
};
module.exports = exports;
